
/**
 * src/web/components/kpi-chart-detail-table.jsx
 * kpi-chart-ranking-table のメンバーの一覧から選択されたユーザのKPI実績
 */

import React from 'react'
import connect, { prepareActualRecords, arrayInTotal, getActualRecords } from '../../connects/kpi-chart-detail-table'
import Avatar from 'react-toolbox/lib/avatar'
import FontIcon from 'react-toolbox/lib/font_icon'
import {
  Button,
} from 'react-toolbox/lib/button'
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
} from 'react-toolbox/lib/table'
import Input from './compact-input.jsx'
import { formatNumber, percent } from '../../helpers/format-number'
import _ from 'lodash'
import moment from 'moment'
import kpiChartTableTheme from './themes/kpi-chart-table.css'
import Tooltip from 'react-toolbox/lib/tooltip'
import userAgent from './user-agent'

function ActualCell(props) {
  const {
    i,
    j,
    t,
    ui,
    value,
    display,
    format,
    updatable,
    reported_at,
    updateUI,
    updateActualRecord,
    kpi_name,
    kpi_id,
    group,
    displayGroupMemberErrorMessage,
  } = props

  var step = 1
  if (format && format.decimal_1)
    step = 0.1
  else if (format && format.decimal_2)
    step = 0.01
  else if (format && format.decimal_3)
    step = 0.001

  if (updatable && ui.editRows[i] && ui.editRows[i][j])
    return (
      <TableCell>
        <form onSubmit={(ev)=> {
                ev.preventDefault()
                updateActualRecord(kpi_id, kpi_name, reported_at, ui.editRows[i][j].value)
              }} >
          <Input value={ui.editRows[i][j].value} hasFocus
              type='number'
              step={step}
              style={{ padding: 0, fontSize: 13, textAlign: 'right' }}
              onBlur={(ev)=> {
                // Firefoxではinput type=numberだとonBlurイベントがおかしくなる
                // https://tirdadc.github.io/blog/2015/06/11/react-dot-js-firefox-issue-with-onblur/
                if (ev.nativeEvent.explicitOriginalTarget &&
                    ev.nativeEvent.explicitOriginalTarget == ev.nativeEvent.originalTarget)
                  return
                updateActualRecord(kpi_id, kpi_name, reported_at, ui.editRows[i][j].value);
              }}
              onChange={(value)=>
                updateUI({ editRows: Object.assign({}, ui.editRows, {[i]: Object.assign({}, ui.editRows[i], {[j]: { value }}) }) })
              } />
        </form>
      </TableCell>
    )
  else {
    var TooltipTableCell = updatable ? Tooltip(TableCell) : TableCell
    return (
      <TooltipTableCell numeric
          style={{ cursor: 'pointer' }}
          tooltip={t('label:クリックして値を更新')}
          onClick={()=> {
            if (updatable && !group.is_member) {
              displayGroupMemberErrorMessage(group.name)
              return
            }
            updatable && updateUI({ editRows: Object.assign({}, ui.editRows, {[i]: Object.assign({}, ui.editRows[i], {[j]: { value }}) }) })
          }}>
        {display}
      </TooltipTableCell>
    )
  }
}

class KPIChartDetailTable extends React.Component {
  render() {
    const {
      t,
      ui,
      kpi,
      selected_user_id,
      selected_user_name,
      selectedKPIs,
      kpis,
      kpiUI,
      user,
      group,
      skipRows,
      updateUI,
      updateActualRecord,
      toggleSkipRows,
      onClose,
      displayGroupMemberErrorMessage,
    } = this.props

    let total_actual_records = []
    _.map(selectedKPIs, selected_kpi => {
      const kpi = kpis.find(item => item.kpi_id == selected_kpi.kpi_id)
      if (kpi) {
        const kpi_actual_records = getActualRecords(
          kpi.assignments,
          selected_user_id,
          kpi.accumulated_total,
          kpiUI.aggregationType,
          moment(kpiUI.tableSelectedDate).format('YYYY-MM-DD'),
          moment(kpiUI.tableStartDate).format('YYYY-MM-DD'),
          moment(kpiUI.tableEndDate).format('YYYY-MM-DD')
        )
        const last_record = kpi_actual_records[kpi_actual_records.length - 1]
        total_actual_records.push({
          kpi_id: kpi.kpi_id,
          accumulated_total: kpi.accumulated_total,
          name: kpi.name,
          display_format: kpi.display_format,
          prepend_unit: kpi.prepend_unit,
          unit: kpi.unit,
          actual_records: kpi_actual_records,
          last_record: last_record,
        })
      }
    })

    // Set initial KPI index
    let lastKpiIndex = -1;

    return (
      <div style={{ padding: 15 }}>
        <div style={{ display: 'flex' }}>
          <strong style={{ paddingLeft: 5, paddingTop: 5 }}>
            {t('label:担当者の実績', { name: selected_user_name })}
          </strong>
          <Button label={t('label:戻る')} icon='arrow_back' onClick={onClose} style={{ marginLeft: 'auto' }}/>
        </div>
        <Table selectable={false} theme={kpiChartTableTheme}>
          {_.map(total_actual_records, (total_actual_record, i) => {
            // Display the KPI title whenever the kpi changes
            const isNewKpi = lastKpiIndex != i
            lastKpiIndex = i
            return [
              isNewKpi && total_actual_record.actual_records.length > 0 && (
                <TableRow key={`kpi_title_${i}`} style={{ fontWeight: 'bold' }}>
                  <TableCell>{total_actual_record.name}</TableCell>
                  <TableCell numeric>{t('label:目標値2')}</TableCell>
                  <TableCell numeric>{t('label:実績')}</TableCell>
                  <TableCell numeric>{t('label:累計')}</TableCell>
                  <TableCell numeric>{t('label:達成率')}</TableCell>
                </TableRow>
              ),
              _.map(total_actual_record.actual_records, (item, j) =>
                ui.skipRows[i] && ui.skipRows[i][j] && !ui.skipRows[i][j].skip &&
                  <TableRow key={`kpi_row_${i}_${j}`}>
                    <TableCell
                      onClick={() => toggleSkipRows(this.props, i, j)}
                      style={{ cursor: 'pointer' }}>
                      {ui.skipRows[i][j].skip_count > 0 && <FontIcon value={'arrow_drop_down'} />}
                      {!ui.skipRows[i][j].skip_count && <span style={{width: 24, display: 'inline-block'}} />}
                      {moment(item.reported_at).format('LLLL')}
                    </TableCell>
                    <TableCell numeric>
                      {total_actual_record.prepend_unit && total_actual_record.unit}
                      {typeof item.total != 'undefined' && formatNumber(item.tbl_target, { decimal_1: true })}
                      {!total_actual_record.prepend_unit && total_actual_record.unit}
                    </TableCell>
                    <ActualCell i={i} j={j} ui={ui} t={t}
                      kpi_id={total_actual_record.kpi_id}
                      kpi_name={total_actual_record.name}
                      updatable={group.is_admin || user.user_id == selected_user_id}
                      group={group}
                      displayGroupMemberErrorMessage={displayGroupMemberErrorMessage}
                      value={item.actual}
                      reported_at={item.reported_at}
                      format={total_actual_record.display_format}
                      display={(total_actual_record.prepend_unit && total_actual_record.unit || '') + formatNumber(item.actual, total_actual_record.display_format) + (!total_actual_record.prepend_unit && total_actual_record.unit || '')}
                      updateUI={updateUI}
                      updateActualRecord={updateActualRecord} />
                    <TableCell numeric>
                      {total_actual_record.prepend_unit && total_actual_record.unit}
                      {typeof item.total != 'undefined' && kpiUI.aggregationType == 'daily_total_01' ? '-' : formatNumber(item.tbl_total, total_actual_record.display_format)}
                      {kpiUI.aggregationType != 'daily_total_01' && !total_actual_record.prepend_unit && total_actual_record.unit}
                    </TableCell>
                    <TableCell numeric>{percent(item.percent)}%</TableCell>
                  </TableRow>
              ),
              isNewKpi && total_actual_record.actual_records.length > 0 && (
                <TableRow key={`kpi_total_${i}`} style={{ fontWeight: 'bold' }}>
                  <TableCell style={{ textAlign:'right' }}>{t('label:合計')}</TableCell>
                  <TableCell numeric>
                    {formatNumber(total_actual_record.last_record.total_target, total_actual_record.display_format)}
                    {!total_actual_record.prepend_unit && total_actual_record.unit}
                  </TableCell>
                  <TableCell numeric>
                    {kpiUI.aggregationType == 'daily_total_01' ? '-' : total_actual_record.last_record.total}
                    {kpiUI.aggregationType != 'daily_total_01' && !total_actual_record.prepend_unit && total_actual_record.unit}
                  </TableCell>
                  <TableCell numeric>
                    {kpiUI.aggregationType == 'daily_total_01' ? '-' : total_actual_record.last_record.total}
                    {kpiUI.aggregationType != 'daily_total_01' && !total_actual_record.prepend_unit && total_actual_record.unit}
                  </TableCell>
                  <TableCell numeric>
                    {kpiUI.aggregationType == 'daily_total_01' ? '-' : percent(total_actual_record.last_record.percent) + '%'}
                  </TableCell>
                </TableRow>
              ),
            ]
          })}
        </Table>
      </div>
    )
  }
}

export default connect(KPIChartDetailTable)



// WEBPACK FOOTER //
// ./src/web/components/kpi-chart-detail-table.jsx